export default __webpack_public_path__ + "static/media/044-no-smoking.6673dcc6.png";